import styled from 'styled-components'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails
} from '@material-ui/core'

export const Wrapper = styled.div``

export const StyledAccordion = styled(Accordion)`
  /* background-color: ${({ theme }) => theme.colors.mainBg} !important; */
  margin-bottom: 12px !important;
  border-radius: 6px !important;
  /* .Mui-expanded {
    background-color: ${({ theme }) => theme.colors.primary} !important;

    path {
      fill: #fff !important;
    }
  } */
`

export const Title = styled.label`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: 600;
  color: ${({ theme }) => theme.ds.colors.primary600};
  text-transform: capitalize;
`

export const StyledAccordionSummary = styled(AccordionSummary)`
  /* background-color: ${({ theme }) => theme.colors.mainBg} !important; */
  /* border: 2px solid ${({ theme }) => theme.colors.primary} !important; */
  border-radius: 6px !important;

  .Mui-expanded {
    label {
      /* color: ${({ theme }) => theme.colors.white} !important; */
    }
  }
`

export const StyledAccordionDetails = styled(AccordionDetails)``
